// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2407":"09104f104b66627b","16497":"3e5d36fe3ea0734c","29246":"fde45b7613fcfbbc","74749":"935fe9d2472e320e","78350":"d0ba7cfc89b87bd5"}[chunkId] + ".css";
};